import CONFIG from "../config/config";

const languageToLocaleMap: { [key: string]: string } = {
    'en': 'EN_US',
    'es': 'ES_ES',
    'it': 'IT_IT',
    'pt': 'PT_PT',
    'uk': 'UK_UA',
    'de': 'DE_DE',
    'pl': 'PL_PL'
  };

export function isSupportedLanguage(type?: string): boolean {
    if (!!type) {
        return CONFIG.SUPPORTED_LANGUAGES.filter(lan => lan.code.toLowerCase() === type.toLowerCase()).length > 0;
    }
    return false;
}

export function languageToLocale(language: string): string {
    return languageToLocaleMap[language] || 'EN_US';
}